<template>
  <div style="background-color: #f0f0f0; height: 100%;min-height: 765px;" >
    <div class="content">
      <el-row>
        <el-col :span="16" class="el-left">
          <el-container
            class="xian"
            v-for="(item, index) in newlist1"
            :key="index"
          >
            <router-link
              tag="div"
              :to="{ name: 'newsdetails', query: { id: item.ID } }"
            >
              <el-container>
                <el-aside width="280px"
                  ><img
                    class="tu"
                    v-bind:src="
                      $store.state.baseurl + '/res/news/' + item.cover
                    "
                    :onerror="defaultImg"
                    alt=""
                /></el-aside>
                <el-main class="ctncn">
                  <p class="p1">{{ item.title }}</p>
                  <div class="p2" v-html="item.content"></div>
                  <p class="p3">{{ item.time }}</p>
                </el-main>
              </el-container>
            </router-link>
          </el-container>
        </el-col>
        <el-col :span="7" class="el-right">
          <div class="zixun">
            <div class="line" style="float: left">
              <span>新闻资讯</span>
              <img style="margin-left: 25px" src="../assets/line-290.png" alt />
            </div>
            <div
              class="ctncn xian"
              v-for="(item, index) in newlist2"
              :key="index"
            >
              <router-link
                tag="div"
                :to="{ name: 'newsdetails', query: { id: item.ID } }"
              >
                <p class="p2">
                  {{ item.title }}
                </p>
                <p class="p3">{{ item.time }}</p>
              </router-link>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      newlist1: [],
      newlist2: [],
      defaultImg: `this.src="${require("../assets/index_book.jpg")}"`,
    };
  },
  created() {
    this.$http.get(`${this.$store.state.baseurl}/api/newslist`).then((res) => {
      const json = res.data;
      const obj = JSON.parse(json);
      this.newlist1 = obj.data;
      this.newlist2 = obj.recommend;
      console.log(this.options[0].navigation);
    });
  },
};
</script>

<style scoped lang="scss">
.content {
  width: 1200px;
  margin: auto;
  padding-top: 15px;
}
.el-left {
  background-color: #ffffff;
}
.el-right {
  background-color: #ffffff;
  margin-left: 22px;
}
.xian {
  border-bottom: 1px dashed #eeeeee;
  cursor: pointer;
}
.zixun {
  float: left;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
}

.ctncn {
  text-align: left;
  .p1 {
    font-size: 20px;
  }
  .p2 {
    font-size: 13px;
    color: #676767;
    word-break: break-all;
    word-wrap: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 46px;
  }
  .p3 {
    font-size: 13px;
    color: #676767;
    text-align: right;
  }
}
.tu {
  height: 130px;
  width: 232px;
  margin: 20px;
}
</style>
